import api from './api';
import { HmgPermission, HmgPermissionFormData, GroupedPermissions } from '../types';

export const permissionService = {
  async getAll(search = '', module?: string, action?: string): Promise<HmgPermission[]> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (module) params.append('module', module);
    if (action) params.append('action', action);

    const response = await api.get<HmgPermission[]>(`/hmg/permissions?${params}`);
    return response.data;
  },

  async getGrouped(): Promise<GroupedPermissions[]> {
    const response = await api.get<GroupedPermissions[]>('/hmg/permissions/grouped');
    return response.data;
  },

  async getModules(): Promise<string[]> {
    const response = await api.get<string[]>('/hmg/permissions/modules');
    return response.data;
  },

  async getById(id: number): Promise<HmgPermission> {
    const response = await api.get<HmgPermission>(`/hmg/permissions/${id}`);
    return response.data;
  },

  async create(data: HmgPermissionFormData): Promise<HmgPermission> {
    const response = await api.post<HmgPermission>('/hmg/permissions', data);
    return response.data;
  },

  async update(id: number, data: HmgPermissionFormData): Promise<HmgPermission> {
    const response = await api.put<HmgPermission>(`/hmg/permissions/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/hmg/permissions/${id}`);
  },
};
